



























import Element from '../../mixins/element';
import CardType from '../CardType.vue';
import { Component } from 'vue-property-decorator';

import { hardCodeBrand, getCardType, validateCard, clearCard } from '../../../services';

import payment from 'payment';

@Component({
    components: {
        CardType,
    },
})
export default class CreditCard extends Element {
    public forceFormatCard(value) {
        if (!payment.fns.validateCardNumber(value) || !validateCard(value)) {
            return;
        }
        (this.$refs.input as any).value = value.match(getCardType(value, true).format).join(' ');
    }

    public toMount(): void {
        this.onLoading(false);
        // tslint:disable-next-line
        this.$parent.$on('creditCardForceInput', (data: string) => {
            (this.$refs.input as any).value = data;
            // tslint:disable-next-line
            (this.$refs.input as any).dispatchEvent(new CustomEvent('input', {}));
            this.forceFormatCard(data);
        });

        (this.$refs.input as any).onpaste = (e) => {
            this.$once('serialized', () => {
                if (!getCardType((this.$refs.input as any).value)) {
                    if (new RegExp(/^[0-9]*$/g).test(this.input.value.replace(/\s+/g, ''))) {
                        const value = this.input.value.substr(0, 19);
                        this.input = {
                            value: clearCard(value),
                            brand: payment.fns.cardType(value),
                        };
                    } else {
                        this.toClear();
                    }
                }
                this.forceFormatCard(this.input.value);
            });
        };
        // payment works bad if use v-model
        (this.$refs.input as any).onchange = (e) => {
            this.input = {
                value: clearCard(e.target.value),
                brand: hardCodeBrand(getCardType(e.target.value)),
            };
        };
        payment.formatCardNumber((this.$refs as any).input);
    }

    public toDestroy(): void {
        // destroyed
    }

    public toValidate(): boolean {
        return validateCard(this.input.value);
    }

    public toClear(): void {
        (this.$refs.input as any).value = '';
    }

    public toFocus(): void {
        (this.$refs as any).input.focus();
    }

    public toBlur(): void {
        (this.$refs as any).input.blur();
    }
}
